import React from "react";
import { IssueSearch } from "@adsk/acc-issues-common/components/input/IssueSearch";
import { IssueTable } from "../IssueTable";
import { IssuesTableFilterButton } from "./IssuesTableFilterButton";
import { IssuesTableProvider } from "./IssuesTableProvider";
import { IssuesTableExportButton } from "./IssuesTableExportButton";
import { IssuesTableBulkActionButtons } from "./IssuesTableBulkActionButtons";
import { Issue } from "@adsk/acc-issues-types";

export interface IssuesTableProps {
  initialIssueId?: string;
  onIssueClick?: (issue: Issue) => void;
  renderEmptyState?: (
    defaultEmptyState: React.ReactNode,
    details?: {
      isSearched: boolean;
      isFiltered: boolean;
    }
  ) => React.ReactElement;
}
export function IssuesTable({
  initialIssueId,
  onIssueClick,
  renderEmptyState,
}: IssuesTableProps) {
  return (
    <IssueTable
      initialIssueId={initialIssueId}
      onIssueClick={onIssueClick}
      renderEmptyState={renderEmptyState}
    />
  );
}

IssuesTable.Search = IssueSearch;
IssuesTable.Provider = IssuesTableProvider;
IssuesTable.Filter = IssuesTableFilterButton;
IssuesTable.ExportButton = IssuesTableExportButton;
IssuesTable.BulkActionButtons = IssuesTableBulkActionButtons;
